<template>
  <div>
    <eli-component
      :eliPathResultType="eliPathResultType"
      :eliPathResultInfo="eliPathResultInfo"
    ></eli-component>
  </div>
</template>

<script>
import EliComponent from "@/components/EliComponent.vue";


export default {
  name: "EliViewActPage",
  props: ["renderData"],
  data() {
    return {
      baseSLGLApiUrl: window.env.VUE_APP_API_SLGL_DEV,
      eliPathResultInfo: [],
      eliPathResultType: null,
    };
  },
  components: {
    EliComponent,
  },
  mounted() {
    this.eliPathResultInfo = this.renderData.eliPathResultInfo;
    this.eliPathResultType = this.renderData.eliPathResultType;

    if (
      this.renderData.eliPathResultType === 3 &&
      this.renderData.eliPathResultInfo.length === 1
    )
      this.$router.push(this.renderData.eliPathResultInfo[0].url);
  },
};
</script>
